import React from "react"
import { ViraIconButton, type ViraIconButtonProps } from "../atoms/ViraIconButton"
import { ViraIcon } from "../atoms/ViraIcon"

export type NavCollapseControlProps = Omit<ViraIconButtonProps, "children"> & {
  collapsed?: boolean
  label?: string
}

export function NavCollapseControl({
  collapsed = false,
  label = collapsed ? "Expand sidebar" : "Collapse sidebar",
  ...rest
}: NavCollapseControlProps) {
  return (
    <ViraIconButton
      variant="outlined"
      aria-label={label}
      aria-pressed={collapsed}
      {...rest}
    >
      <ViraIcon
        name={collapsed ? "chevronRight" : "collapse"}
        tone="subtle"
        sx={{ fontSize: 14 }}
      />
    </ViraIconButton>
  )
}
